import queryString from 'qs'

export function parse(query: string) {
  return queryString.parse(query)
}

export function stringfy(object: any) {
  return queryString.stringify(object)
}
